import { useMap } from '@vis.gl/react-google-maps';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';

import PlusIcon from 'assets/v2/PlusIcon';
import SubtractIcon from 'assets/v2/SubtractIcon';

import { MAX_ZOOM } from '../../constants';
import { MapControlButton, MapControlButtonContainer } from '../../Map.styles';

const ZoomControl = ({ minZoom = 0, maxZoom = 22 }) => {
  const map = useMap();

  const [zoom, setZoom] = useState(MAX_ZOOM);

  const isZoomInDisabled = useMemo(
    () => !map || zoom >= maxZoom,
    [zoom, maxZoom],
  );
  const isZoomOutDisabled = useMemo(
    () => !map || zoom <= minZoom,
    [zoom, minZoom],
  );

  const handleZoomIn = useCallback(() => {
    if (!map) return;

    map.setZoom(map.getZoom() + 1);
  }, [map]);

  const handleZoomOut = useCallback(() => {
    if (!map) return;

    map.setZoom(map.getZoom() - 1);
  }, [map]);

  useEffect(() => {
    if (!map) return () => {};

    // Identify initial zoom level
    setZoom(map.getZoom());

    // Listen for zoom changes
    const zoomListener = map.addListener('zoom_changed', () => {
      setZoom(map.getZoom());
    });

    return () => {
      zoomListener.remove();
    };
  }, [map]);

  return (
    <MapControlButtonContainer>
      <MapControlButton onClick={handleZoomIn} disabled={isZoomInDisabled}>
        <PlusIcon size="20px" />
      </MapControlButton>
      <MapControlButton onClick={handleZoomOut} disabled={isZoomOutDisabled}>
        <SubtractIcon size="20px" />
      </MapControlButton>
    </MapControlButtonContainer>
  );
};

ZoomControl.propTypes = {
  minZoom: PropTypes.number,
  maxZoom: PropTypes.number,
};

export default memo(ZoomControl);
